import { stateCode } from '../../data/usStates';

export function formatDeliveryAddress(defaults) {
  return [
    defaults.shipToAddress1,
    defaults.shipToAddress2,
    [defaults.shipToCity, defaults.shipToState, defaults.shipToZip].filter(Boolean).join(', '),
  ]
    .filter(Boolean)
    .join(' · ');
}

export function hasCompleteDeliveryAddress(defaults) {
  return ['facilityOrOffices', 'shipToAddress1', 'shipToCity', 'shipToState', 'shipToZip'].every(
    (key) => defaults[key]?.trim()
  );
}

export function createDefaultsDraft(clinic) {
  return {
    ...clinic.defaults,
    shipToState: stateCode(clinic.defaults.shipToState),
    defaultPreferredCarrier: clinic.defaults.defaultPreferredCarrier || 'fedex',
    defaultSignatureNote: clinic.defaults.defaultSignatureNote || 'none',
  };
}

export function filterClinicOrderForms(clinics, { includeRemoved, search }) {
  const query = search.trim().toLowerCase();

  return clinics.filter((clinic) => {
    if (!includeRemoved && clinic.removed) return false;
    const searchable = `${clinic.name} ${clinic.companyName} ${clinic.defaults.facilityOrOffices} ${formatDeliveryAddress(clinic.defaults)}`;
    return searchable.toLowerCase().includes(query);
  });
}
